import 'primeicons/primeicons.css';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Sidebar } from './window/Sidebar.js';
import { MainToolbar } from './window/Toolbar.js';
import { ToolProvider, ToolsContext } from './ToolsContext.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './Queries.js';
import { SnapshotProvider } from './SnapshotContext.js';
import { PrimeReactProvider } from 'primereact/api';
import { OverlayProvider } from './OverlaysContext.js';
import { MainPanel } from './window/MainPanel.js';
import { useContext } from 'react';
import { RMapContextProvider } from 'maplibre-react-components';

export function App() {
  const value = { // primereact conf
    zIndex: {
      modal: 99100,    // dialog, sidebar
      overlay: 99000,  // dropdown, overlaypanel
      menu: 99000,     // overlay menus
      tooltip: 99100,   // tooltip
      toast: 99200     // toast
    },
    autoZIndex: true,

  };

  return (
    <QueryClientProvider client={queryClient}>
      <PrimeReactProvider value={value}>
        <RMapContextProvider>
          <SnapshotProvider>
            <ToolProvider>
              <OverlayProvider>
                <MainWindow />
              </OverlayProvider>
            </ToolProvider>
          </SnapshotProvider>
        </RMapContextProvider>
      </PrimeReactProvider>
    </QueryClientProvider>
  );
}

function MainWindow() {
  const tool = useContext(ToolsContext);

  if (tool.name === 'timetablesTool') {
    // wyjątkowy (uproszczony) układ okna głównego dla edytora liniówek
    return (
      <>
        <MainToolbar />
        <MainPanel />
      </>
    )
  }

  //normalne okno
  return (
    <>
        <MainToolbar />
        <Splitter style={{ height: '100%' }}>
          <SplitterPanel size={25} minSize={10}>
            <Sidebar />
          </SplitterPanel>
          <SplitterPanel size={75} className="align-items-center justify-content-center">
            <MainPanel />
          </SplitterPanel>
        </Splitter>
    </>
  )
}
